import { CheckCircle2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";

const NETWORKS = ["facebook", "instagram", "threads"];

export const PublishTargets = ({
  outlets, targets, setTargets, oneClick, setOneClick,
  socialNets, setSocialNets, cardTemplate, setCardTemplate,
}) => {
  if (!(outlets || []).length) return null;
  return (
    <div className="border border-border bg-muted/30 p-4 mb-6 flex flex-wrap items-center gap-3"
         data-testid="publish-targets">
      <span className="kicker text-muted-foreground">Publicar en</span>
      {outlets.map((o) => {
        const on = (targets || []).includes(o.id);
        return (
          <button
            key={o.id}
            type="button"
            onClick={() => setTargets(on ? targets.filter((x) => x !== o.id) : [...(targets || []), o.id])}
            className={`text-sm px-3 py-1.5 border transition-colors ${on
              ? "border-primary bg-primary text-primary-foreground"
              : "border-border hover:border-primary/60 text-muted-foreground"}`}
            data-testid={`target-${o.id}`}
          >
            {on && <CheckCircle2 className="h-3.5 w-3.5 mr-1.5 inline" />}{o.name}
          </button>
        );
      })}
      <span className="text-xs text-muted-foreground">
        Solo se enviará a los medios marcados.
      </span>
      <div className="w-full border-t border-border pt-3 mt-1" data-testid="one-click-panel">
        <label className="flex items-center gap-2 text-sm cursor-pointer">
          <Switch checked={oneClick} onCheckedChange={setOneClick} data-testid="one-click-switch" />
          <span>Publicar con un clic: al terminar en WordPress, publicar en redes con la tarjeta del medio</span>
        </label>
        {oneClick && (
          <div className="flex flex-wrap items-center gap-2 mt-3">
            {NETWORKS.map((n) => {
              const on = socialNets.includes(n);
              return (
                <button key={n} type="button"
                  onClick={() => setSocialNets(on ? socialNets.filter((x) => x !== n) : [...socialNets, n])}
                  className={`text-xs px-3 py-1.5 border capitalize transition-colors ${on
                    ? "border-primary bg-primary text-primary-foreground"
                    : "border-border text-muted-foreground hover:border-primary/60"}`}
                  data-testid={`one-click-net-${n}`}>
                  {n}
                </button>
              );
            })}
            <select
              value={cardTemplate}
              onChange={(e) => setCardTemplate(e.target.value)}
              className="h-9 border border-input bg-background px-2 text-xs rounded-md"
              data-testid="one-click-template-select"
            >
              <option value="">Plantilla predeterminada del medio</option>
              {outlets
                .filter((o) => (targets || []).includes(o.id))
                .flatMap((o) => (o.card_templates || []).map((t) => (
                  <option key={t.id} value={t.id}>{`${o.name} · ${t.name}`}</option>
                )))}
            </select>
          </div>
        )}
      </div>
    </div>
  );
};
